import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AssetComponent } from '@mkp/shared/ui-asset';
import { DataTestDirective } from '@mkp/tracking/feature-tracking';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, LINK_BUTTON_DEFAULT_CONFIG } from './../../elements/index';

export type PromptLinkRoute = string | (string | number)[];

@Component({
  selector: 'ui-prompt-link',
  templateUrl: './prompt-link.component.html',
  styleUrl: './prompt-link.component.scss',
  imports: [AssetComponent, ButtonComponent, DataTestDirective, RouterLink, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromptLinkComponent {
  readonly linkConfig = LINK_BUTTON_DEFAULT_CONFIG;

  readonly prompt = input.required<string>();
  readonly link = input.required<string>();
  readonly dataTest = input.required<string>();
  // required so a link with nothing behind it cannot be declared by omission:
  // `null` opts into `linkClick` instead
  readonly route = input.required<PromptLinkRoute | null>();

  readonly icon = input<string>();
  readonly disabled = input(false);

  readonly linkClick = output<void>();
}
